/**
 * @generated SignedSource<<ed1e0fdaa8b8c2b52498c58ce2ef2736>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreativeList$data = {
  readonly metaAds: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"MetaAd">;
  }>;
  readonly " $fragmentType": "CreativeList";
};
export type CreativeList$key = {
  readonly " $data"?: CreativeList$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreativeList">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "metaAdsFilter"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreativeList",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "metaAdsFilter",
          "variableName": "metaAdsFilter"
        }
      ],
      "concreteType": "MetaAd",
      "kind": "LinkedField",
      "name": "metaAds",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MetaAd"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Brand",
  "abstractKey": null
};

(node as any).hash = "08c42481abc7fa1bb98b8547b534ff58";

export default node;
